/* FAQ de la page Contact — recherche par mots-clés (section mc-contact-faq).
   La saisie est découpée en mots, les mots vides ignorés, chaque mot ramené
   à une racine simple (pluriels s/x, finales -er/-ée/-ement, y→i : « payer »,
   « payée » et « paiement » se rejoignent). Une question sort si elle
   contient AU MOINS UN mot-clé, dans sa question, sa réponse ou le libellé
   de son thème. Classement : d'abord toutes-les-correspondances, puis
   nombre de mots trouvés, un mot trouvé dans la question comptant plus
   (3 points) qu'en réponse ou thème (1 point). Pendant la recherche, les
   groupes de thèmes laissent place à une liste classée ; les mots trouvés
   sont surlignés et le meilleur résultat s'ouvre. Champ vidé : tout revient
   à sa place. Le module est chargeable en Node pour les tests de logique. */

(function () {
  'use strict';

  var MOTS_VIDES = [
    'le', 'la', 'les', 'de', 'du', 'des', 'un', 'une', 'et', 'ou', 'je', 'j',
    'mon', 'ma', 'mes', 'ton', 'ta', 'tes', 'est', 'a', 'pour', 'sur', 'en',
    'au', 'aux', 'ce', 'ca', 'qu', 'que', 'quoi', 'comment',
    'ne', 'd', 'l', 'c', 'n', 's', 't', 'm', 'y', 'il', 'elle', 'on', 'se',
    'sa', 'ses', 'son', 'nous', 'vous', 'notre', 'nos', 'votre', 'vos',
    'dans', 'par', 'avec', 'si', 'quand', 'me', 'te', 'moi', 'toi',
    'es', 'sont', 'suis', 'etre', 'ai', 'as'
  ];

  function normalise(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .replace(/y/g, 'i');
  }

  function decoupe(s) {
    return normalise(s).match(/[a-z0-9]+/g) || [];
  }

  /* Racine simple : retire une finale courante si au moins 3 lettres restent. */
  var FINALES = ['ements', 'ement', 'ees', 'ee', 'es', 'er', 's', 'x'];

  function racine(mot) {
    for (var i = 0; i < FINALES.length; i++) {
      var f = FINALES[i];
      if (mot.length - f.length >= 3 && mot.slice(-f.length) === f) {
        return mot.slice(0, -f.length);
      }
    }
    return mot;
  }

  /* Tolérance : racines égales, ou l'une préfixe de l'autre (≥ 3 lettres) —
     « abonn » trouve « abonnement » et « abonnée ». */
  function correspond(racineDoc, racineCle) {
    if (racineDoc === racineCle) return true;
    var mini = Math.min(racineDoc.length, racineCle.length);
    if (mini < 3) return false;
    return racineDoc.indexOf(racineCle) === 0 || racineCle.indexOf(racineDoc) === 0;
  }

  function motCorrespond(mot, racinesCles) {
    var r = racine(normalise(mot).replace(/[^a-z0-9]/g, ''));
    for (var i = 0; i < racinesCles.length; i++) {
      if (correspond(r, racinesCles[i])) return true;
    }
    return false;
  }

  function analyseRequete(saisie) {
    var racines = [];
    decoupe(saisie).forEach(function (mot) {
      if (MOTS_VIDES.indexOf(mot) !== -1) return;
      var r = racine(mot);
      if (r && racines.indexOf(r) === -1) racines.push(r);
    });
    return racines;
  }

  /* items : [{ question, reponse, theme }] (textes bruts, sans HTML).
     Retour : { racines, resultats } — resultats triés, null si la saisie
     ne contient aucun mot-clé (pas de filtre à appliquer). */
  function classe(items, saisie) {
    var racinesCles = analyseRequete(saisie);
    if (!racinesCles.length) return { racines: racinesCles, resultats: null };
    var notes = [];
    items.forEach(function (it, index) {
      var racinesQ = decoupe(it.question).map(racine);
      var racinesR = decoupe((it.reponse || '') + ' ' + (it.theme || '')).map(racine);
      var touches = 0;
      var score = 0;
      racinesCles.forEach(function (cle) {
        var enQuestion = racinesQ.some(function (r) { return correspond(r, cle); });
        if (enQuestion) { touches++; score += 3; return; }
        var enReponse = racinesR.some(function (r) { return correspond(r, cle); });
        if (enReponse) { touches++; score += 1; }
      });
      if (touches > 0) {
        notes.push({ index: index, touches: touches, score: score, tous: touches === racinesCles.length });
      }
    });
    notes.sort(function (a, b) {
      if (a.tous !== b.tous) return a.tous ? -1 : 1;
      if (a.touches !== b.touches) return b.touches - a.touches;
      if (a.score !== b.score) return b.score - a.score;
      return a.index - b.index;
    });
    return { racines: racinesCles, resultats: notes };
  }

  var api = {
    MOTS_VIDES: MOTS_VIDES,
    normalise: normalise,
    racine: racine,
    correspond: correspond,
    motCorrespond: motCorrespond,
    analyseRequete: analyseRequete,
    classe: classe
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.McCfaqRecherche = api;

  /* --- Câblage de la page (navigateur uniquement) --- */
  if (typeof document === 'undefined') return;

  function initSection(racineEl) {
    var champ = racineEl.querySelector('[data-cfaq-recherche]');
    var vide = racineEl.querySelector('[data-cfaq-vide]');
    var resultats = racineEl.querySelector('[data-cfaq-resultats]');
    var groupes = Array.prototype.slice.call(racineEl.querySelectorAll('[data-cfaq-groupe]'));
    if (!champ || !resultats) return;

    var elements = [];
    groupes.forEach(function (groupe) {
      var titreTheme = (groupe.querySelector('.mc-cfaq__theme') || {}).textContent || '';
      var liste = groupe.querySelector('.mc-cfaq__liste');
      Array.prototype.slice.call(groupe.querySelectorAll('[data-cfaq-item]')).forEach(function (el) {
        elements.push({
          el: el,
          liste: liste,
          question: (el.querySelector('.mc-cfaq__question span') || {}).textContent || '',
          reponse: (el.querySelector('.mc-cfaq__reponse') || {}).textContent || '',
          theme: titreTheme,
          questionEl: el.querySelector('.mc-cfaq__question span'),
          reponseEl: el.querySelector('.mc-cfaq__reponse')
        });
      });
    });

    function demarque() {
      Array.prototype.slice.call(racineEl.querySelectorAll('mark[data-cfaq-marque]')).forEach(function (mk) {
        mk.replaceWith(document.createTextNode(mk.textContent));
      });
      elements.forEach(function (it) {
        if (it.questionEl) it.questionEl.normalize();
        if (it.reponseEl) it.reponseEl.normalize();
      });
    }

    function marque(el, racinesCles) {
      if (!el) return;
      var marcheur = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var noeuds = [];
      while (marcheur.nextNode()) noeuds.push(marcheur.currentNode);
      noeuds.forEach(function (noeud) {
        var texte = noeud.nodeValue;
        var re = /[A-Za-z0-9À-ɏ]+/g;
        var fragments = [];
        var dernier = 0;
        var trouve = false;
        var m;
        while ((m = re.exec(texte))) {
          if (motCorrespond(m[0], racinesCles)) {
            trouve = true;
            if (m.index > dernier) fragments.push(document.createTextNode(texte.slice(dernier, m.index)));
            var mk = document.createElement('mark');
            mk.setAttribute('data-cfaq-marque', '');
            mk.textContent = m[0];
            fragments.push(mk);
            dernier = m.index + m[0].length;
          }
        }
        if (!trouve) return;
        if (dernier < texte.length) fragments.push(document.createTextNode(texte.slice(dernier)));
        var parent = noeud.parentNode;
        fragments.forEach(function (f) { parent.insertBefore(f, noeud); });
        parent.removeChild(noeud);
      });
    }

    function fermeAutoOuverts() {
      elements.forEach(function (it) {
        if (it.el.hasAttribute('data-cfaq-auto')) {
          it.el.open = false;
          it.el.removeAttribute('data-cfaq-auto');
        }
      });
    }

    function restaure() {
      demarque();
      fermeAutoOuverts();
      elements.forEach(function (it) { it.liste.appendChild(it.el); });
      groupes.forEach(function (g) { g.hidden = false; });
      resultats.hidden = true;
      vide.hidden = true;
    }

    champ.addEventListener('input', function () {
      var saisie = champ.value.trim();
      if (saisie === '') { restaure(); return; }
      var r = classe(elements, saisie);
      if (r.resultats === null) { restaure(); return; }

      demarque();
      fermeAutoOuverts();
      groupes.forEach(function (g) { g.hidden = true; });
      /* Remet d'abord chaque item dans son groupe (caché), puis déplace
         les retenus, classés, dans la liste de résultats. */
      elements.forEach(function (it) { it.liste.appendChild(it.el); });
      r.resultats.forEach(function (note) {
        resultats.appendChild(elements[note.index].el);
      });
      resultats.hidden = r.resultats.length === 0;
      vide.hidden = r.resultats.length > 0;
      r.resultats.forEach(function (note) {
        var it = elements[note.index];
        marque(it.questionEl, r.racines);
        marque(it.reponseEl, r.racines);
      });
      if (r.resultats.length) {
        var meilleur = elements[r.resultats[0].index].el;
        meilleur.open = true;
        meilleur.setAttribute('data-cfaq-auto', '');
      }
    });

    /* Bouton de transition : descend jusqu'au formulaire de contact. */
    var descendre = racineEl.querySelector('[data-cfaq-descendre]');
    if (descendre) {
      descendre.addEventListener('click', function () {
        var formulaire = document.querySelector('.mc-contact-form');
        if (formulaire) formulaire.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.mc-cfaq')).forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
